type FetcherArgs = [RequestInfo, RequestInit | undefined];

export const fetcher = async (...args: FetcherArgs) => {
	const [url, options] = args;

	const response = await fetch(url, options);

	return response.json();
};
